// extracted by mini-css-extract-plugin
export default {"container":"_ae6d7767","iconComponent":"_3c3d1564","iconInfo":"_a9005ae5","text":"_4761207d","boldText":"_4f2b6078","tooltip":"_5956ff15"};